import { render, staticRenderFns } from "./editGoal.vue?vue&type=template&id=3866962e&scoped=true"
import script from "./editGoal.vue?vue&type=script&lang=js"
export * from "./editGoal.vue?vue&type=script&lang=js"
import style0 from "./editGoal.vue?vue&type=style&index=0&id=3866962e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3866962e",
  null
  
)

export default component.exports